import { render, staticRenderFns } from "./reportdetail.vue?vue&type=template&id=62967de7&scoped=true&"
import script from "./reportdetail.vue?vue&type=script&lang=js&"
export * from "./reportdetail.vue?vue&type=script&lang=js&"
import style0 from "./reportdetail.vue?vue&type=style&index=0&id=62967de7&lang=scss&scoped=true&"
import style1 from "./reportdetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62967de7",
  null
  
)

export default component.exports